import axios from 'axios';
import {axiosConfig as config} from 'config/axiosConfig';

const {REACT_APP_API} = process.env;
const baseUrl = `${REACT_APP_API}/centers`;

export const getAll = async ({page = '', limit = '', codeCenter = '', name = '', openingHours = '', direction = ''}) => {
 const {data} = await axios.get(`${baseUrl}/?page=${page}&limit=${limit}&codeCenter=${codeCenter}&name=${name}&openingHours=${openingHours}&direction=${direction}`, config) 
 return data
}

export const create = async ({center = {}}) => {
 const {data} = await axios.post(baseUrl, center, config)
 return data
}

export const update = async ({center = {}, id}) => {
 const {data} = await axios.put(`${baseUrl}/${id}`, center, config)
 return data
}

export const del = async ({id}) => {
 const {data} = await axios.delete(`${baseUrl}/${id}`, config)
 return data
}